








































































import { Mixins, Component } from "vue-property-decorator";
import { DialogMixin } from "../../../../../../../base/components/system/mixins";
import { ObjectUtility } from "../../../../../../../base/utilities";
import { IQuestionnaireOption } from "../../../../../../../documaker/domain/format/objects";
import { QuestionnaireAnswerOptionSelector } from "../selectors";

@Component({
  components: {
    QuestionnaireAnswerOptionSelector,
  }
})
export default class QuestionnaireAnswerOptionEditDialog extends Mixins(DialogMixin) {
  options: IQuestionnaireOption[] = [];
  selectedOptions: IQuestionnaireOption[] = [];
  selectedOption: IQuestionnaireOption = null;

  optionDisplay: string = "";
  optionCode: string = "";

  confirmed: boolean = false;

  get validOption(): boolean {
    return this.optionDisplay.trim().length > 0 && this.optionCode.trim().length > 0;
  }

  get hasSelectedOptions(): boolean {
    return this.selectedOptions.length > 0;
  }

  get hasSelectedOption(): boolean {
    return this.selectedOption !== null;
  }

  get isTopSelectedOption(): boolean {
    return this.hasSelectedOptions && this.selectedOptions.some(v => v === this.options[0]);
  }

  get isBottomSelectedOption(): boolean {
    return this.hasSelectedOptions && this.selectedOptions.some(v => v === this.options[this.options.length - 1]);
  }

  async show(options: IQuestionnaireOption[]): Promise<IQuestionnaireOption[]> {
    return this.showModal(async () => {
      this.options = ObjectUtility.copyDeeply(options) as IQuestionnaireOption[];
      this.selectedOptions = [];
      this.selectedOption = null;
      this.optionDisplay = "";
      this.optionCode = "";

      this.confirmed = false;
      await this.waitHidden();
      return this.confirmed
        ? this.options
        : null;
    });
  }

  addOption() {
    const option = {
      valueCoding: {
        code: this.optionCode,
        display: this.optionDisplay,
      }
    };
    this.options = this.options.concat(option);
    this.selectedOption = option;
  }

  updateOption() {
    this.selectedOption.valueCoding.display = this.optionDisplay;
    this.selectedOption.valueCoding.code = this.optionCode;
  }

  moveOptions(offset: number) {
    const indexes = this.selectedOptions.map(v => this.options.indexOf(v)).sort((a, b) => a - b);
    if (offset > 0) {
      indexes.reverse();
    }
    indexes.forEach(i => this.moveItem(i, offset));
  }

  private moveItem(index: number, offset: number) {
    const item = this.options[index];
    this.options.splice(index, 1);
    this.options.splice(index + offset, 0, item);
  }

  removeOptions() {
    this.options = this.options.filter((v) => !this.selectedOptions.some(s => s === v));
  }

  changeSelectedOption(value: IQuestionnaireOption) {
    this.selectedOption = value;
    if (value) {
      this.optionDisplay = value.valueCoding.display;
      this.optionCode = value.valueCoding.code;
    }
  }

  changeOptions(value: IQuestionnaireOption[]) {
    this.selectedOptions = value;
  }

  confirm(): void {
    this.confirmed = true;
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }
}
